var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScorecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.2988,
    height: 42.2988,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81225 37.0112C7.8429 37.0112 7.01308 36.666 6.32279 35.9758C5.6325 35.2855 5.28735 34.4556 5.28735 33.4863V8.81201C5.28735 7.84266 5.6325 7.01284 6.32279 6.32255C7.01308 5.63226 7.8429 5.28711 8.81225 5.28711H24.6743V8.81201H8.81225V33.4863H33.4865V17.6243H37.0114V33.4863C37.0114 34.4556 36.6663 35.2855 35.976 35.9758C35.2857 36.666 34.4559 37.0112 33.4865 37.0112H8.81225ZM12.3371 29.9614H15.862V17.6243H12.3371V29.9614ZM19.3869 29.9614H22.9118V12.3369H19.3869V29.9614ZM26.4367 29.9614H29.9616V22.9116H26.4367V29.9614ZM29.9616 15.8618V12.3369H26.4367V8.81201H29.9616V5.28711H33.4865V8.81201H37.0114V12.3369H33.4865V15.8618H29.9616Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScorecard);
export default __webpack_public_path__ + "static/media/scorecard.ead35bfd57b91462ed220007fd6af42b.svg";
export { ForwardRef as ReactComponent };